import { render, staticRenderFns } from "./AddV2.vue?vue&type=template&id=150f9ebf&scoped=true"
import script from "./AddV2.vue?vue&type=script&lang=js"
export * from "./AddV2.vue?vue&type=script&lang=js"
import style0 from "./AddV2.vue?vue&type=style&index=0&id=150f9ebf&prod&lang=css"
import style1 from "./AddV2.vue?vue&type=style&index=1&id=150f9ebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f9ebf",
  null
  
)

export default component.exports